'use client';
import React from 'react';


interface TaskbarApp {
  id: string;
  label: string;
  sublabel: string;
  icon: React.ElementType;
  route: string;
  color: string;
}

interface TaskbarProps {
  apps: TaskbarApp[];
  activeAppId?: string;
  onAppClick: (route: string) => void;
  currentTime: string;
}

export default function Taskbar({ apps, activeAppId, onAppClick, currentTime }: TaskbarProps) {
  return (
    <div
      className="wt-taskbar h-14 flex items-center justify-between px-4 border-t border-wt-border/50 shrink-0"
      style={{ background: 'rgba(7,12,20,0.97)', backdropFilter: 'blur(16px)' }}
    >
      {/* App buttons */}
      <div className="flex items-center gap-1">
        {apps.map(app => {
          const isActive = app.id === activeAppId;
          return (
            <button
              key={`taskbar-${app.id}`}
              onClick={() => onAppClick(app.route)}
              className={`taskbar-item flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs transition-all duration-150 ${isActive ? 'active' : ''}`}
              style={{
                background: isActive ? `${app.color}18` : 'transparent',
                borderBottom: isActive ? `2px solid ${app.color}` : '2px solid transparent',
              }}
              title={app.label}
              suppressHydrationWarning
            >
              <app.icon size={14} style={{ color: isActive ? app.color : '#7a9ab8' }} />
              <span className={`hidden sm:block font-medium ${isActive ? 'text-wt-text' : 'text-wt-muted'}`}>{app.label}</span>
            </button>
          );
        })}
      </div>

      {/* Right side */}
      <div className="flex items-center gap-3">
        <span className="font-mono text-xs text-wt-muted tabular-nums hidden sm:block">29-04-2026</span>
        <div className="w-px h-4 bg-wt-border" />
        <span className="font-mono text-xs text-wt-primary tabular-nums">{currentTime || '00:00:00'}</span>
      </div>
    </div>
  );
}